import { types } from 'mobx-state-tree'
import { ForDirectExtend } from '../mobx'

const _Attachment = types.model({
  url: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  extname: types.maybeNull(types.string),
  size: types.maybeNull(types.number),
  mimeType: types.maybeNull(types.string)
})

interface AttachmentType extends ForDirectExtend<typeof _Attachment> {}
const Attachment: AttachmentType = _Attachment

export default Attachment
